/**
 * Mensagem para falha na busca de orçamento. 404 = orçamento não existe;
 * 5xx/sem resposta = a integração com o Brinde.me (odforge) está fora do ar,
 * e dizer "não encontrado" nesse caso levaria a pessoa a achar que digitou errado.
 */
export const sourceLookupErrorMessage = (error: any, notFound = 'Orçamento não encontrado'): string => {
    const status = error?.response?.status
    if (status === 404) return error?.response?.data?.message ?? notFound
    if (!status || status >= 500) {
        return 'Não foi possível consultar o Brinde.me agora (integração indisponível). Tente novamente em alguns minutos.'
    }
    return error?.response?.data?.message ?? notFound
}
